// store/store.js
import { configureStore } from "@reduxjs/toolkit";
import hotelFacilityReducer from "../features/facility/facilitySlice";
import hotelAmenityReducer from "../features/amenity/amenitySlice";
import hotelAdminReducer from "../features/admin/adminSlice";
import roomCategoryReducer from "../features/roomCategory/roomCategorySlice";
import hotelReducer from "../features/hotel/hotelSlice";
import bookingReducer from "../features/booking/bookingSlice";
import contactReducer from "../features/contact/contactSlice";
import userReducres from "../../../Redux/Reducer";


const store = configureStore({
  reducer: {
    hotelAdmin: hotelAdminReducer,
    hotelFacility: hotelFacilityReducer,
    hotelAmenity: hotelAmenityReducer,
    hotelRoomCategory: roomCategoryReducer,
    hotel: hotelReducer,
    booking: bookingReducer,
    data: userReducres,
    contact: contactReducer,
  },
});

export default store;
